import React from "react";

import { Breadcrumbs, Col, Crumb, MainPage, Row } from "components";

export type Share = {
  title?: string;
  summary?: string;
  image?: string;
  link?: string;
  htmlTitle?: string;
  htmlDescription?: string;
};

type SubPageProps = {
  pageName: string;
  share: Share;
  crumbs: Crumb[];
  children: React.ReactNode;
  dataTestId?: string;
  afterPage?: React.ReactNode;
  beforePage?: React.ReactNode;
  containerClass?: string;
  fullWidth?: boolean;
  loading?: boolean;
  className?: string;
  crumbSide?: React.ReactNode;
};
export const SubPage = ({
  afterPage,
  beforePage,
  children,
  containerClass = "",
  fullWidth,
  loading,
  pageName,
  share,
  dataTestId,
  className,
  crumbs,
  crumbSide,
}: SubPageProps) => (
  <MainPage
    afterPage={afterPage}
    beforePage={beforePage}
    containerClass={containerClass}
    fullWidth={fullWidth}
    loading={loading}
    pageName={pageName}
    share={share}
    dataTestId={dataTestId}
    className={className}
  >
    <Row justify="space-around" align="middle">
      <Col sm={crumbSide ? 12 : 24} md={crumbSide ? 8 : 24}>
        <Breadcrumbs items={crumbs} />
      </Col>
      <Col sm={crumbSide ? 12 : 0} md={crumbSide ? 16 : 0}>
        {crumbSide}
      </Col>
    </Row>
    {children}
  </MainPage>
);
